import { UNIVERSAL_ENDING } from '../../config'

const thirdWay = {
    '3': {
        cardId: 'leaveApplication',
        reaction: {
            modalId: 'everythingIsOk',
            actions: [{
                type: 'addCards',
                data: ['managerSignature', 'hrDepartment'],
            }]
        },
        next: ['3.1', '3.2', '3.3']
    },
    '3.1': {
        cardId: 'datesAgreement',
        reaction: {
            modalId: 'managerDoesntRemember',
            actions: [
                {
                    type: 'addCards',
                    data: ['vacationSchedule'],
                },
                { type: 'returnToBacklog' }
            ],
        },
        next: ['3.1.1', '3.1.2']
    },
    '3.2': {
        cardId: 'managerSignature',
        reaction: {
            modalId: 'managerDoesntRemember',
            actions: [
                {
                    type: 'addCards',
                    data: ['vacationSchedule'],
                },
                { type: 'returnToBacklog' }
            ],
        },
        next: ['3.1.1', '3.1.2']
    },
    '3.3': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'hrOneEye'
        },
        next: ['2', '3.1', '3.2']
    },
    '3.1.1': {
        cardId: 'colleaguesVacations',
        reaction: {
            modalId: 'runOverAll',
            actions: [
                {
                    type: 'addCards',
                    data: ['colleagueAgree', 'managerArbiting']
                }
            ],
        },
        next: ['3.1.1.1', '3.1.1.2']
    },
    '3.1.2': {
        cardId: 'vacationSchedule',
        reaction: {
            modalId: 'notActualGraph'
        },
        next: ['3.1.1']
    },
    '3.1.1.1': {
        cardId: 'colleagueAgree',
        reaction: {
            rndEnding: {
                type: 'lose',
                message: 'Антон запланировал отпуск с семьёй и не может перенести. И хотя вы помните, что в начале года Антон планировал другие даты, поделать ничего не можете: у него отпуск уже согласован, а одновременно уйти вам не позволяет работа.<br/> Желаем, чтобы в вашей компании появился EmployeeGate, ведь с ним всё гораздо быстрее: не нужно искать шаблон  заявления и высчитывать дату подачи — всё просто заполняется в личном кабинете. А ещё вы всегда видите, кто замещает руководителя, а руководители видят график отпусков своих подчинённых.'
            },
            modalId: 'youAreLucky',
            actions: [
                {
                    type: 'addCards',
                    data: ['hrDepartment']
                }
            ],
        },
        next: ['3.1.1.1.1', '3.1.1.1.2']
    },
    '3.1.1.2': {
        cardId: 'managerArbiting',
        reaction: {
            modalId: 'managerSendYouOff'
        },
        next: ['3.1.1.1']
    },
    '3.1.1.1.1': {
        cardId: 'managerSignature',
        reaction: {
            modalId: 'datesDoNotOverlap'
        },
        next: ['3.1.1.1.1.1']
    },
    '3.1.1.1.2': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'hrFoundFault',
            actions: [
                {
                    type: 'addCards',
                    data: ['rewriteApplication'],
                },
                { type: 'returnToBacklog' }
            ],
        },
        next: ['3.1.1.1.2.1']
    },
    '3.1.1.1.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'hrFoundFault',
            actions: [
                {
                    type: 'addCards',
                    data: ['rewriteApplication'],
                },
                { type: 'returnToBacklog' }
            ],
        },
        next: ['3.1.1.1.1.1.1']
    },
    '3.1.1.1.2.1': {
        cardId: 'rewriteApplication',
        reaction: {
            actions: [
                {
                    type: 'addCards',
                    data: ['managerSignature']
                }
            ]
        },
        next: ['3.1.1.1.2.1.1', '3.1.1.1.2.1.1.1']
    },
    '3.1.1.1.1.1.1': {
        cardId: 'rewriteApplication',
        actions: [
            {
                type: 'addCards',
                data: ['managerSignature'],
            }
        ],
        next: ['3.1.1.1.1.1.1.1', '3.1.1.1.2.1.1.1']
    },
    '3.1.1.1.2.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'hrOneEye',
            actions: [
                {
                    type: 'addCards',
                    data: ['managerSignature'],
                }
            ]
        },
        next: ['3.1.1.1.2.1.1.1']
    },
    '3.1.1.1.1.1.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'unpaidLeave',
            actions: [
                {
                    type: 'addCards',
                    data: ['managerAdditionalVacationsAgree'],
                },
                { type: 'returnToBacklog' }
            ]
        },
        next: ['3.1.1.1.1.1.1.1.1']
    },
    '3.1.1.1.2.1.1.1': {
        cardId: 'managerSignature',
        reaction: {
            modalId: 'bossIsAway',
            actions: [
                {
                    type: 'addCards',
                    data: ['findSignatureOfAnotherManager', 'dismissal']
                }
            ]
        },
        next: ['3.1.1.1.2.1.1.1.1', '3.1.1.1.2.1.1.1.2']
    },
    '3.1.1.1.1.1.1.1.1': {
        cardId: 'managerAdditionalVacationsAgree',
        reaction: {
            modalId: 'unpaidLeaveIsOk',
            actions: [
                {
                    type: 'addCards',
                    data: ['rewriteApplication', 'managerSignature', 'hrDepartment']
                }
            ]
        },
        next: ['3.1.1.1.1.1.1.1.1.1']
    },
    '3.1.1.1.2.1.1.1.1': {
        cardId: 'findSignatureOfAnotherManager',
        reaction: {
            modalId: 'bitterExperience',
            actions: [
                {
                    type: 'addCards',
                    data: ['hrDepartment']
                }
            ]
        },
        next: ['3.1.1.1.2.1.1.1.1.1', '3.1.1.1.2.1.1.1.1.2']
    },
    '3.1.1.1.2.1.1.1.2': {
        cardId: 'dismissal',
        ending: {
            type: 'lose',
            message: `Что ж, понимаем вас. Работать в компании, где так сложно оформить отпуск, не очень приятно: когда кадровые вопросы отнимают так много времени, сил на основные задачи уже не остаётся. Надеемся, на вашем следующем месте работы будет установлен EmployeeGate.<br/>
        Осталось написать заявление на увольнение. Но это уже совсем другая игра...`
        }
    },
    '3.1.1.1.1.1.1.1.1.1': {
        cardId: 'rewriteApplication',
        reaction: {
            type: 'lose',
            message: UNIVERSAL_ENDING
        }
    },
    '3.1.1.1.2.1.1.1.1.2': {
        cardId: 'hrDepartment',
        reaction: {
            type: 'lose',
            message: `Упс, кажется, вы отправили прошлый вариант заявления, и HR-отдел его опять отклонил. Вы переписали и подписали его, но не успели отправить в рабочее время — HR-специалист уже ушёл. А в понедельник будет поздно, так что отдохнёте в другой раз.<br/>
            Желаем, чтобы в вашей компании появился EmployeeGate, ведь с ним всё гораздо быстрее: не нужно искать шаблон заявления и высчитывать дату подачи — всё просто заполняется в личном кабинете. А ещё вы всегда видите, кто замещает руководителя, а руководители видят график отпусков своих подчинённых.`
        }
    },
    '3.1.1.1.2.1.1.1.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            rndEnding: {
                type: 'win',
                message: `Ура, собирайте чемоданы! Кажется, вы уже сталкивались со всеми сложностями при оформлении отпуска и научились на своих ошибках.<br/>
                Упростите жизнь себе и всем сотрудникам компании, внедрив EmployeeGate. Например, с личным кабинетом не нужно искать шаблон заявления и высчитывать дату подачи, сотрудники всегда видят, кто замещает руководителя, а руководители видят график отпусков своих подчинённых. Так высокооплачиваемые специалисты не будут тратить рабочее время на формальности.`
            },
        }
    }
}

export default thirdWay